import { PaymentFormComponentsProps } from '@/app/components/ppra/components/ppra-payment-page/PPRAPaymentPage';
import validationService from '@/services/validation.service';
import { FormControl } from '@chakra-ui/react';
import { Box, Text } from '@cmpsr/components';
import { useElements } from '@stripe/react-stripe-js';
import '../../../payment-reset.css';

type ZipCodeInputV2Props = PaymentFormComponentsProps & { getPrice: () => void };

export default function ZipCodeInputV2({ form, getPrice }: ZipCodeInputV2Props) {
  const element = useElements();

  const validate = (value: string) => {
    const isValid = validationService.validateZip(value);
    if (isValid) {
      element
        ?.getElement('payment')
        ?.update({ defaultValues: { billingDetails: { address: { postal_code: value } } } });
      getPrice();
    }
    return isValid || 'Please provide a valid postal code';
  };

  const formRegistry = form.register('zip', {
    required: 'Please add your postal code',
    validate,
  });

  const hasError = !!form.formState.errors.zip;

  return (
    <Box className="payment-reset" width="100%" display="flex" flexDirection="column" gap={0}>
      <Text
        fontSize="10px"
        fontFamily="Inter"
        fontWeight="400"
        letterSpacing="1px"
        textTransform="uppercase"
        as="label"
        htmlFor="zip"
        color="text-primary"
        mb={0}
      >
        Postal Code
      </Text>
      <FormControl id="zip-code" isInvalid={hasError}>
        <input
          placeholder="Enter your postal code"
          id="zip"
          autoComplete="postal-code"
          {...formRegistry}
          onBlur={(e) => {
            validate(e.currentTarget.value);
            formRegistry.onBlur(e);
          }}
          className="payment-input"
        />
        {hasError && (
          <Text color="salmon-light" fontSize="xs" mt={1}>
            {form.formState.errors.zip?.message}
          </Text>
        )}
      </FormControl>
    </Box>
  );
}
